import script from "./IssueTagger.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueTagger.vue?vue&type=script&lang=ts&setup=true"

import "./IssueTagger.vue?vue&type=style&index=0&id=2fd1c2a4&lang=css"

const __exports__ = script;

export default __exports__